"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHtmlFromVariable = void 0;
var classnames_1 = __importDefault(require("classnames"));
var createHtmlFromVariable = function (token) {
    var className = (0, classnames_1.default)("variable-widget", {
        "variable-widget--bold": token.isBold,
        "variable-widget--italic": token.isItalic,
        "variable-widget--strikethrough": token.isStrikethrough,
    });
    return "<span class=\"".concat(className, "\"><span class=\"variable-name\">").concat(token.label, "</span></span>");
};
exports.createHtmlFromVariable = createHtmlFromVariable;
